import { render, staticRenderFns } from "./manageInventory.vue?vue&type=template&id=66f2d295&"
import script from "./manageInventory.vue?vue&type=script&lang=js&"
export * from "./manageInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports